import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function BarChartWidget({ title, data, labels, unit, color = "#4fc3f7", datasets }) {
  const chartData = {
    labels: labels || ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: datasets
      ? datasets.map((ds) => ({
          label: ds.label,
          data: ds.data,
          backgroundColor: ds.color,
          borderRadius: 4,
        }))
      : [
          {
            label: title,
            data: data || generateMockData(7),
            backgroundColor: color,
            borderRadius: 4,
          },
        ],
  };

  const hasMultipleDatasets = datasets && datasets.length > 1;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: { bottom: 6 },
    },
    plugins: {
      legend: {
        display: hasMultipleDatasets,
        labels: { color: "#8b949e", font: { size: 10 }, boxWidth: 12 },
      },
      tooltip: {
        backgroundColor: "#161b22",
        titleColor: "#8b949e",
        bodyColor: "#fff",
        borderColor: "#30363d",
        borderWidth: 1,
        callbacks: {
          label: (ctx) => `${ctx.parsed.y} ${unit || ""}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#8b949e", font: { size: 10 } },
      },
      y: {
        grid: { color: "#21262d", drawBorder: false },
        ticks: {
          color: "#8b949e",
          font: { size: 10 },
          callback: (val) => `${val}${unit ? ` ${unit}` : ""}`,
        },
      },
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.title}>{title}</span>
      </div>
      <div style={styles.chartWrapper}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
}

function generateMockData(count) {
  return Array.from({ length: count }, () => Math.floor(Math.random() * 100));
}

const styles = {
  container: {
    backgroundColor: "#161b22",
    borderRadius: "8px",
    padding: "8px 10px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    marginBottom: "4px",
  },
  title: {
    color: "#e6edf3",
    fontSize: "12px",
    fontWeight: "500",
  },
  chartWrapper: {
    flex: 1,
    minHeight: 0,
  },
};
